import { Avatar, Badge, Box, Button, Flex, FormatNumber, Grid, GridItem, HStack, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { UI } from "components";
import useCart from "hooks/useCart";
import moment, { duration } from "moment";
import Moment from "react-moment";
import Cart from "./cart";
import { useData } from '../../hooks/useData'
import { useNavigate } from "react-router";
import Distributor from "./distributor";
import { Pressable } from "components/ui";

export default function Heading(){

    const navigate = useNavigate()
    const cart = useCart()
    const { data, setCart } = useData()
    const distributor = useDisclosure()

    return(
    <>
    <Cart open={data?.cart?.open} onClose={() => setCart({ open: false })} />
    <Distributor {...distributor} />

    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)' }} gap={4} mb={4} pb={4} borderBottomWidth={1}>

        <GridItem>

            <HStack gap={4} alignItems="center">
                <Pressable onClick={distributor.onOpen}>
                    <UI.Avatar size="xl" name={cart.data?.distributor_from?.name} />
                </Pressable>

                <Box>
                    <Text fontSize="md" color="GrayText" fontWeight="medium">
                        Você está comprando em:
                    </Text>

                    <Stack direction={{ base: "column", md: "row" }} gap={3} mt={1} alignItems={{ base: "flex-start", md: "center" }}>
                        <Pressable onClick={distributor.onOpen}>
                            <Text fontSize="xl" fontWeight="bold" lineHeight="short">
                                {cart.data?.distributor_from?.name}
                            </Text>
                        </Pressable>

                        <Button
                            size="md"
                            variant="solid"
                            colorPalette="orange"
                            onClick={() => navigate('/loja/nucleos')}

                            // Aumentando a fonte para melhor leitura
                            fontSize="md"
                            fontWeight="bold"

                            // Incluindo o ícone (use 'map-pin', 'location' ou 'edit' dependendo da sua biblioteca)
                            leftIcon={<UI.Icon name="location" />}

                            // Ajustando o arredondamento:
                            // 'md' ou '4px' deixa as pontas levemente quadradas, mas ainda modernas.
                            borderRadius="md"

                            // Um leve padding extra para não sufocar o texto com o ícone
                            px={5}
                        >
                            Trocar local de compra
                        </Button>
                    </Stack>
                </Box>
            </HStack>

        </GridItem>

        <GridItem display="flex" justifyContent={{ base: 'flex-start', md: 'flex-start', lg: 'right' }}>

            <HStack gap={4}>
                <UI.Popover.PopoverRoot>
                    <UI.Popover.PopoverTrigger>
                        <UI.Pressable>
                            <Box>
                                <Text fontSize="xs" color="GrayText">Tempo restante:</Text>
                                <Badge size="lg" colorPalette="red"><UI.Icon name="timer" /> <Moment fromNow interval={1000} children={cart.data?.cart_expire_at} /></Badge>
                            </Box>
                        </UI.Pressable>
                    </UI.Popover.PopoverTrigger>
                    <UI.Popover.PopoverContent>
                        <UI.Popover.PopoverArrow />
                        <UI.Popover.PopoverBody>
                            <Stack>
                                <Text fontWeight="bold">Porque tempo restante?</Text>
                                <Text>
                                    A partir do momento que você adiciona um produto à sacola, o item será reservado no estoque do núcleo 
                                    para que não ocorram vendas acima da capacidade.
                                </Text>
                                <Text fontWeight="bold">O que acontece quando o tempo acaba?</Text>
                                <Text>
                                    Caso você não finalize o pedido antes de o tempo acabar, seu carrinho será reiniciado.
                                </Text>
                                <Text>
                                    Fazemos isso para garantir que todos tenham a mesma oportunidade de compra.
                                </Text>
                            </Stack>
                        </UI.Popover.PopoverBody>
                    </UI.Popover.PopoverContent>
                </UI.Popover.PopoverRoot>

                <UI.Popover.PopoverRoot>
                    <UI.Popover.PopoverTrigger>
                        <UI.Pressable>
                            <Box>
                                <Text fontSize="xs" color="GrayText">Pontos:</Text>
                                <Badge size="lg" colorPalette="orange"><UI.Number.Number value={cart.data?.points} /> pontos</Badge>
                            </Box>
                        </UI.Pressable>
                    </UI.Popover.PopoverTrigger>
                    <UI.Popover.PopoverContent>
                        <UI.Popover.PopoverArrow />
                        <UI.Popover.PopoverBody>
                            <Stack>
                                <Text fontWeight="bold">Pontuação</Text>
                                <Text>
                                    Essa é a quantidade de pontos que seu pedido vai gerar.
                                </Text>
                            </Stack>
                        </UI.Popover.PopoverBody>
                    </UI.Popover.PopoverContent>
                </UI.Popover.PopoverRoot>
                
                <Box>
                    <Text fontSize="xs" color="GrayText">Total:</Text>
                    <Text fontSize="md" fontWeight="bold" color="orange.fg"><FormatNumber value={cart.data?.total_amount / 100} style="currency" currency="BRL" /></Text>
                </Box>

                <Box>
                    <Button hideBelow="sm" size="sm" variant="outline" colorPalette="orange" loading={cart.isFetching} onClick={() => setCart({ open: true })}><UI.Icon name="cart" /> Sacola</Button>
                </Box>
            </HStack>

        </GridItem>

        <GridItem hideFrom="sm"><Button w="100%" size="sm" variant="outline" colorPalette="orange" loading={cart.isFetching} onClick={() => setCart({ open: true })}><UI.Icon name="cart" /> Sacola</Button></GridItem>

    </Grid>
    </>
    )
}